import { useConversationState } from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';
import { useMentionPersonas } from '@web/common/hooks/useMentionPersonas/useMentionPersonas';

export const useConversationPersonas = () => {
  const { memberIds } = useConversationState();

  return useMentionPersonas(memberIds);
};
